import { toast as sonnerToast } from 'sonner';

export const showErrorToast = (message: string) => {
  sonnerToast.error(message, {
    duration: 6000,
    closeButton: true,
    testId: 'toast-error',
  });
};

export const showSuccessToast = (message: string) => {
  sonnerToast.success(message, {
    duration: 4000,
    closeButton: true,
    testId: 'toast-success',
  });
};

// Story 010a — persistent toast for important in-app notifications.
// Doesn't auto-dismiss; the user closes it manually. Returns the toast
// id so the caller can dismiss it programmatically (e.g. on read).
export const showImportantNotificationToast = (title: string): string | number => {
  return sonnerToast(title, {
    duration: Infinity,
    closeButton: true,
    testId: 'toast-important',
  });
};

// PWA service-worker update prompt. Shown when vite-plugin-pwa detects
// a new SW version is waiting. Persistent + action button — users
// explicitly click "Update" to take the new version (which calls
// skipWaiting + reload). Without this, the SW would silently take
// over on next navigation and a long-lived player tab could end up
// reading a new API contract from stale JS mid-session.
export const showUpdateAvailableToast = (
  title: string,
  actionLabel: string,
  onUpdate: () => void,
): string | number => {
  return sonnerToast(title, {
    duration: Infinity,
    closeButton: true,
    testId: 'toast-update-available',
    action: {
      label: actionLabel,
      onClick: onUpdate,
    },
  });
};
